/**
 * Hook que devuelve las secciones del menú visibles para la sesión actual.
 *
 * Toma la sesión de `useAuth` (permisos, rol, flags de sede) y delega el
 * filtrado en `filterNavSections` (pura). Se memoiza por las entradas que
 * influyen en la visibilidad para no recalcular en cada render.
 */
import { useMemo } from "react";

import { useAuth } from "@/lib/auth";

import { filterNavSections } from "./filterNavSections";
import type { NavSection } from "./types";

export function useNavSections(): NavSection[] {
  const { hasPermission, user, sedeInvActivo, sedeLaserActivo } = useAuth();
  const role = user?.role;

  return useMemo(
    () =>
      filterNavSections({ hasPermission, role, sedeInvActivo, sedeLaserActivo }),
    [hasPermission, role, sedeInvActivo, sedeLaserActivo],
  );
}
